import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Field } from "@/components/common";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { REGISTER } from "@/constants/testIds/auth";
import AuthLayout from "./AuthLayout";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ name: "", organization_name: "", email: "", phone: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    if (f.password.length < 8) return setErr("Password must be at least 8 characters.");
    setBusy(true);
    setErr("");
    try {
      await register(f);
      nav("/clinics");
    } catch (ex) {
      setErr(errMsg(ex));
    } finally {
      setBusy(false);
    }
  };
  return (
    <AuthLayout title="Register your clinic group" subtitle="Create your CEO / MD account, then open your first clinic.">
      <form onSubmit={submit} className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <Field label="Full name"><Input required value={f.name} onChange={set("name")} data-testid={REGISTER.nameInput} /></Field>
        <Field label="Organisation"><Input value={f.organization_name} onChange={set("organization_name")} data-testid="register-organization-input" /></Field>
        <Field label="Email"><Input type="email" required value={f.email} onChange={set("email")} data-testid={REGISTER.emailInput} /></Field>
        <Field label="Phone"><Input value={f.phone} onChange={set("phone")} data-testid="register-phone-input" /></Field>
        <Field label="Password (min 8)" className="sm:col-span-2"><Input type="password" required value={f.password} onChange={set("password")} data-testid={REGISTER.passwordInput} /></Field>
        {err && <p className="sm:col-span-2 text-sm text-rose-600" data-testid="register-error">{err}</p>}
        <Button type="submit" disabled={busy} className="sm:col-span-2 rounded-full h-11" data-testid={REGISTER.submitButton}>{busy ? "Creating…" : "Create CEO account"}</Button>
        <p className="sm:col-span-2 text-sm text-slate-500">Already have an account? <Link to="/login" className="font-semibold text-teal-700" data-testid={REGISTER.loginLink}>Sign in</Link></p>
      </form>
    </AuthLayout>
  );
}
